document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector("[data-preview-request]");
    if (!section) return;

    const sectionId = section.dataset.sectionId;

    const button = document.getElementById(`PreviewRequestButton-${sectionId}`);
    const modal = document.getElementById(`PreviewModal-${sectionId}`);
    const confirm = document.getElementById(`PreviewSubmit-${sectionId}`);

    if (!button || !modal || !confirm) return;

    button.addEventListener("click", () => {
        modal.classList.add("open");
    });

    modal.querySelectorAll("[data-preview-close]").forEach(el => {
        el.addEventListener("click", () => {
            modal.classList.remove("open");
        });
    });

confirm.addEventListener("click", async () => {

    const errorBox = modal.querySelector("[data-preview-error]");
    const successBox = modal.querySelector("[data-preview-success]");

    function showError(message) {
        successBox.hidden = true;
        errorBox.textContent = message;
        errorBox.hidden = false;
    }

    function clearError() {
        errorBox.hidden = true;
        errorBox.textContent = "";
    }

    function showSuccess() {
        clearError();
        successBox.hidden = false;
    }

    clearError();

    const productInfo = document.querySelector("product-info");
    const form = document.getElementById("{{ product_form_id }}");

    const productId = productInfo?.dataset.productId;
    const variantId = document.querySelector('input[name="id"]')?.value;

    const uploadId =
        document.querySelector('input[name="properties[upload_id]"]')?.value;

    const uploadedFile =
        document.querySelector('input[type="file"]')?.files?.[0]?.name ?? null;

    const image =
        document.querySelector(".product__media img")?.currentSrc ??
        document.querySelector(".product__media img")?.src;

    const email =
        document.getElementById(`PreviewEmail-${sectionId}`).value.trim();
if (!email) {
    showError("Zadajte svoju e-mailovú adresu.");
    return;
}

if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError("Zadajte platnú e-mailovú adresu.");
    return;
}

    const quantity =
        document.querySelector('input[name="quantity"]')?.value;

    const formValues = {};

    if (form) {
        for (const [key, value] of new FormData(form).entries()) {
            formValues[key] = value;
        }
    }

    const variantOptions = {};

    document.querySelectorAll("variant-selects fieldset").forEach(fieldset => {
        const legend = fieldset.querySelector("legend");
        const checked = fieldset.querySelector("input:checked");

        if (legend && checked) {
            variantOptions[legend.textContent.trim()] = checked.value;
        }
    });

    document.querySelectorAll("variant-selects select").forEach(select => {

        const match = select.name.match(/^options\[(.*)\]$/);
        const optionName = match ? match[1] : select.name;

        variantOptions[optionName] = select.value;
    });

    const debugPayload = {
        productId,
        variantId,
        image,
        uploadId,
        uploadedFile,
        email,
        quantity,
        formValues,
        variantOptions
    };

    const requestBody = {
        email,
        productId,
        variantId,
        uploadedFileName: uploadedFile ?? "",
        style:
            variantOptions["Style"] ??
            variantOptions["Štýl"] ??
            "",
        size:
            variantOptions["Size"] ??
            variantOptions["Veľkosť"] ??
            "",
        optionsJson: JSON.stringify(debugPayload)
    };

    try {

        const response = await fetch(
            "https://api.aipresentstore.com/api/v1/preview-requests",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            }
        );

        if (!response.ok) {
            throw new Error("Request failed");
        }

        showSuccess();

        setTimeout(() => {
            window.location.href = "https://aipresentstore.com/sk-sk/collections/all";
        }, 1500);

    } catch (err) {
        console.error(err);
        showError("Niečo sa pokazilo. Skúste to znova.");
    }

});

});